export default function ZoomImageModal({ activeImage, showImage, setShowImage }: { activeImage?: string, showImage: boolean, setShowImage: (b: boolean) => void }) {
    return (
        <div className={`modal-image ${showImage && 'show'}`}>
            <span className="image-close" onClick={() => setShowImage(false)}>&times;</span>
            <img className="modal-image-content" src={activeImage} />
        </div>
    )
}